import Entity from "lib/models/Entity";
import { computed } from "mobx";
import * as moment from "moment";

import Creator from "./Creator";
import { ProgressStatus } from "lib/enums";

interface PdfSource {
  id: number;
  file: string;
  creator: Creator;
  updatedAt: string;
  progressStatus: number;
}

export default class Pdf extends Entity<PdfSource> {
  @computed
  get file(): string {
    return this.source.file;
  }

  @computed
  get creator(): Creator {
    return this.source.creator;
  }

  @computed
  get updatedAt(): string {
    return moment(this.source.updatedAt).format("lll");
  }

  @computed
  get isComplete(): boolean {
    return this.source.progressStatus === ProgressStatus.COMPLETE;
  }

  @computed
  get progressStatus(): ProgressStatus {
    switch (this.source.progressStatus) {
      case 0:
        return ProgressStatus.INITIAL;
      case 1:
        return ProgressStatus.ONGOING;
      case 2:
        return ProgressStatus.COMPLETE;
      default:
        return ProgressStatus.INITIAL;
    }
  }
}

export type { PdfSource };
